const page404 = {
    tagLine: 'GAINS NIET GEVONDEN',
    button: 'GA TERUG NAAR DE SITE',
    amigoText: "Je bent op de verkeerde pagina maatje, klik alsjeblieft op knop om terug te gaan naar de site of anders word ik groot en sterk en gooi ik je terug!"
}
export default page404